import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const Building01Icon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M12.75 18.75V13.35C12.75 12.7899 12.75 12.5099 12.641 12.296C12.5451 12.1078 12.3922 11.9549 12.204 11.859C11.9901 11.75 11.7101 11.75 11.15 11.75H8.35C7.78995 11.75 7.50992 11.75 7.29601 11.859C7.10785 11.9549 6.95487 12.1078 6.85899 12.296C6.75 12.5099 6.75 12.7899 6.75 13.35V18.75M16.75 18.75V3.95C16.75 2.8299 16.75 2.26984 16.532 1.84202C16.3403 1.46569 16.0343 1.15973 15.658 0.967987C15.2302 0.75 14.6701 0.75 13.55 0.75H5.95C4.82989 0.75 4.26984 0.75 3.84202 0.967987C3.46569 1.15973 3.15973 1.46569 2.96799 1.84202C2.75 2.26984 2.75 2.8299 2.75 3.95V18.75M18.75 18.75H0.75M7.25 5.75H7.26M12.25 5.75H12.26M7.75 5.75C7.75 6.02614 7.52614 6.25 7.25 6.25C6.97386 6.25 6.75 6.02614 6.75 5.75C6.75 5.47386 6.97386 5.25 7.25 5.25C7.52614 5.25 7.75 5.47386 7.75 5.75ZM12.75 5.75C12.75 6.02614 12.5261 6.25 12.25 6.25C11.9739 6.25 11.75 6.02614 11.75 5.75C11.75 5.47386 11.9739 5.25 12.25 5.25C12.5261 5.25 12.75 5.47386 12.75 5.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
